import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=88f94e4c&scoped=true"
import script from "./uploadList.vue?vue&type=script&lang=js"
export * from "./uploadList.vue?vue&type=script&lang=js"
import style0 from "./uploadList.vue?vue&type=style&index=0&id=88f94e4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f94e4c",
  null
  
)

export default component.exports